import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/nl';
export const locale = {
  lang: 'nl',
  data: {
    'CONSULTA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
        'PRODUCTOS': catalogos.productos,
      },
      'TITULO': 'Enquêtekalender',
      'SUBTITULO': 'Raadpleeg de informatie van de enquêtes die in het platform zijn gegenereerd in een bepaald bereik.',
      'TXT_RANG_DAT': 'Voer een datumbereik in',
      'BTN_CANC':'Annuleren',
      'BTN_APLI':'Toepassen',
      'MOD_TITT_INFO': 'Enquête-informatie',
      'TXT_NAM_COMPA': 'Bedrijfsnaam:  ',
      'TXT_NAM_TOKEN':'Enquêteteken:  ',
      'TXT_DAT_LAN': 'Startdatum:  ',
      'TXT_DAT_CLOS': 'Sluitingsdatum:  ',
      'TXT_SUR_STA': 'Land van enquête:  ',
      'TXT_TIP_SUR': 'Producttype:  ',
      'TXT_YEA_SUR': 'Enquêtejaar:  ',
      'ESTATUS':{
        '0': 'Inactief',
        '1': 'Actief',
        '2': 'Gesloten',
      },
      'CAMPOS': {
        'broker': 'Broker',
      },
    }
  }
};
